module.exports = __webpack_public_path__ + "static/media/class-pending.e0db888f.svg";